export const MIGRATION_CUTOFF_LOCAL_DOC_ID = "migrationCutoff";
//# sourceMappingURL=MigrationCutoff.js.map